import React, { useEffect, useState } from "react";
import {
  GetAllAdminDetails,
  getcandidateDetails,
  getCandidateLead,
  GetCompanyName,
  getTentativeCount,
} from "../../apiServices";
import {
  convertDateYYYYMMDD,
  dateFormateDD,
  decryptedAdminID,
  MyModal,
  sources,
} from "../../utility";
import ModalContainer from "../../components/modal_popup";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineClose, AiOutlinePhone } from "react-icons/ai";
import {
  Pagination,
  FormControl,
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { Table } from "react-bootstrap";
import { commonPopupActions } from "../../redux-store/store";
import { FaFilter } from "react-icons/fa";

const formatDate = (date) => date.toISOString().split("T")[0];

// Get next Monday
const getNextMonday = (date) => {
  const d = new Date(date);
  const day = d.getDay(); // 0=Sun
  const diff = (8 - day) % 7 || 7;
  d.setDate(d.getDate() + diff);
  return d;
};

// Get Saturday from Monday
const getSaturdayFromMonday = (monday, weeks = 1) => {
  const d = new Date(monday);
  d.setDate(d.getDate() + (weeks * 7 - 2)); // Saturday
  return d;
};

const TentativeAnalytics = () => {
  const dispatch = useDispatch();
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetailsRole.roleID === 1;

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, settotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  const [adminList, setAdminList] = useState([]);
  const [companyNames, setCompanyNames] = useState([]);

  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [openFilter, setOpenFilter] = useState(false);
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const [filters, setFilters] = useState({
    fromDate: convertDateYYYYMMDD(new Date()),
    toDate: convertDateYYYYMMDD(new Date()),
    companyName: "",
    assignTo: isSuperAdmin ? "" : decryptedAdminID(),
    dateFilterType: "Today",
    mobileNumber: "",
    fromSource: "",
  });

  const [dateRange, setDateRange] = useState({
    start: filters.fromDate,
    end: filters.toDate,
    dateFilterType: filters.dateFilterType,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showCustom, setshowCustom] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });

  const open = Boolean(anchorEl);

  const fetchData = async (pageNo = page) => {
    try {
      setLoading(true);
      const res = await getTentativeCount({
        ...filters,
        page: pageNo,
        size: 10,
      });

      setData(res?.data || []);
      setTotalPages(res?.totalPages || 1);
      settotalRecords(res?.totalRecords || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);
  const handleDateClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    GetAllAdminDetails()
      .then((res) => {
        const activeAdmins = res.filter(
          (a) => !a.Deactived && a.Module !== "Developer"
        );
        setAdminList(activeAdmins);
      })
      .catch(() => alert("Failed to load admins"));
  }, []);

  /* ================= LOAD COMPANIES ================= */
  useEffect(() => {
    (async () => {
      const res = await GetCompanyName();
      setCompanyNames(res?.companyDetails || []);
    })();
  }, []);

  /* ================= HANDLERS ================= */
  const handlePageChange = (_, value) => {
    setPage(value);
  };

  const handleCandidateDetails = async (id, type) => {
    const data =
      type === "RegisterCandidate"
        ? await getcandidateDetails(id)
        : await getCandidateLead(id);

    dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id,
        type,
        data,
      })
    );
  };

  const handleApplyFilter = () => {
    setPage(1);
    fetchData(1);
    setOpenFilter(false);
  };

  const handleClearFilter = () => {
    setFilters({
      fromDate: convertDateYYYYMMDD(new Date()),
      toDate: convertDateYYYYMMDD(new Date()),
      dateFilterType: "today",
      companyName: "",
      assignTo: isSuperAdmin ? "" : decryptedAdminID(),
      mobileNumber: "",
      fromSource: "",
    });

    setDateRange({
      start: "",
      end: "",
      dateFilterType: "",
    });

    setSelectedCompany(null);
    setSelectedAdmin(null);
    setPage(1);
    fetchData(1);
  };

  const handleDateSelect = (val) => {
    const today = new Date();
    let startDate;
    let endDate;
    let label = "";

    switch (val) {
      case "today":
        label = "Today";
        startDate = new Date(today);
        endDate = new Date(today);
        break;

      case "tomorrow":
        label = "Tomorrow";
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() + 1);
        endDate = new Date(startDate);
        break;

      case "nextweek": {
        label = "Next Week";
        startDate = getNextMonday(today); // Monday
        endDate = getSaturdayFromMonday(startDate, 1); // Saturday
        break;
      }

      case "nextTwoWeek": {
        label = "Next 2 Week";
        startDate = getNextMonday(today);
        endDate = getSaturdayFromMonday(startDate, 2);
        break;
      }

      case "nextMonth": {
        label = "Next Month";
        startDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 2, 0); // last day of month
        break;
      }

      case "custom":
        setshowCustom(true);
        setAnchorEl(null);
        setDateRange((prev) => ({
          ...prev,
          dateFilterType: "Custom",
        }));
        return;

      default:
        return;
    }

    const start = formatDate(startDate);
    const end = formatDate(endDate);

    // ✅ UI state
    setDateRange({
      start,
      end,
      dateFilterType: label,
    });

    // ✅ API filter state
    setFilters((prev) => ({
      ...prev,
      fromDate: start,
      toDate: end,
      dateFilterType: label,
    }));

    setAnchorEl(null);
  };

  function handleCustomDate(value, type) {
    const val = value.target.value;

    if (type === "startDate") {
      setDateRange((prev) => ({
        ...prev,
        start: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        end: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  }

  const isFormValid = () => {
    // Implement your validation logic here
    // For example, you can check if both start and end dates are filled
    const isValid = dateRange.start && dateRange.end;

    if (!dateRange.start) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!dateRange.end) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };

  const handleApplyDate = (e) => {
    e.preventDefault();

    if (!dateRange.start || !dateRange.end) {
      setValidationErrors({
        start: !dateRange.start,
        end: !dateRange.end,
      });
      return;
    }

    setFilters((prev) => ({
      ...prev,
      fromDate: dateRange.start,
      toDate: dateRange.end,
      dateFilterType: "custom",
    }));

    setValidationErrors({ start: false, end: false });
    setshowCustom(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCandidateIDChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);

    setFilters((prev) => ({
      ...prev,
      mobileNumber: value,
    }));
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");

    const numbersOnly = pastedText.replace(/\D/g, "").slice(-10);

    setFilters((prev) => ({
      ...prev,
      mobileNumber: numbersOnly,
    }));
  };

    function handleFieldChange(field, value) {
    switch (field) {
      case "mobileNumber":
        // Check if the value is numeric before updating the state
        if (/^\d*$/.test(value) || value === "") {
          setFilters((prev) => ({ ...prev, [field]: value }));
        }
        break;

      default:
        setFilters((prev) => ({ ...prev, [field]: value }));
        break;
    }
  }

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-end mb-3 align-items-center gap-3">
        <b>Total Records : {totalRecords} </b>
        <button className="btn btn-success" onClick={() => setOpenFilter(true)}>
          <FaFilter /> Filter
        </button>
      </div>

      <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Mobile</th>
              <th>Company</th>
              <th>Job Category</th>
              <th>From Source</th>
              {isSuperAdmin && <th>Assigned To</th>}
              <th>Tentative Date</th>
            </tr>
          </thead>
          <tbody>
            {!loading && data.length ? (
              data.map((row, i) => (
                <tr key={i}>
                  <td
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleCandidateDetails(
                        row.candidate_id || row.can_lead_id,
                        row.candidate_id ? "RegisterCandidate" : "CandidateLead"
                      )
                    }
                  >
                    {row.first_name || row.last_name || "-"}
                  </td>
                  <td>{row.mobile_number || "-"}</td>
                  <td>{row.company_name || "-"}</td>
                  <td>{row.suggested_jobcategory || "-"}</td>
                  <td>{row.from_source || "-"}</td>
                  {isSuperAdmin && <td>{row.user_name || "-"}</td>}
                  <td>{dateFormateDD(row.tentative_interview_date)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-danger">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-center mt-3">
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="success"
          size="small"
        />
      </div>

      {openFilter && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div className="p-3" style={{ width: "500px" }}>
                  <div className="d-flex justify-content-between mb-3">
                    <div>
                      <b>Filter</b>
                    </div>
                    <div>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => setOpenFilter(false)}
                      >
                        <AiOutlineClose />
                      </button>
                    </div>
                  </div>

                  <TextField
                    label="Mobile Number"
                    variant="outlined"
                    fullWidth
                    value={filters.mobileNumber}
                    className="mb-2"
                    onChange={handleCandidateIDChange}
                    onPaste={handlePaste}
                    inputProps={{
                      maxLength: 10,
                      inputMode: "numeric",
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AiOutlinePhone style={{ marginRight: 5 }} />
                          +91
                        </InputAdornment>
                      ),
                    }}
                  />

                  {isSuperAdmin && (
                    <FormControl fullWidth className="mb-2">
                      <Autocomplete
                        options={adminList}
                        getOptionLabel={(o) => o.userName || ""}
                        value={selectedAdmin}
                        onChange={(_, value) => {
                          setSelectedAdmin(value);
                          setFilters((prev) => ({
                            ...prev,
                            assignTo: value ? value.id : "",
                          }));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Assigned To" />
                        )}
                      />
                    </FormControl>
                  )}

                  <TextField
                    label="Company Name"
                    fullWidth
                    value={filters.companyName}
                    className="mb-2"
                    onChange={(e) => {
                      const value = e.target.value;

                      // allow only letters and spaces
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setFilters((prev) => ({
                          ...prev,
                          companyName: value,
                        }));
                      }
                    }}
                  />

                  <FormControl variant="outlined" fullWidth className="mb-2">
                    <TextField
                      label="Tentative on"
                      id="basic-button"
                      value={`${dateRange.dateFilterType}`}
                      // value={`${dateRange.start} - ${dateRange.end}`}
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleDateClick}
                    ></TextField>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDateSelect("today");
                        }}
                        style={{ width: "210px" }}
                      >
                        Today
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleDateSelect("tomorrow");
                        }}
                      >
                        Tomorrow
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleDateSelect("nextweek");
                        }}
                      >
                        Next Week
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleDateSelect("nextTwoWeek");
                        }}
                      >
                        Next 2 Week
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleDateSelect("nextMonth");
                        }}
                      >
                        Next Month
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleDateSelect("custom");
                        }}
                      >
                        Custom Date
                      </MenuItem>
                    </Menu>
                  </FormControl>
                  {/*  */}
                  {showCustom && (
                    <MyModal>
                      <ModalContainer
                        zIndex={1005}
                        childComponent={
                          <div
                            style={{
                              minWidth: "400px",
                              width: "auto",
                            }}
                          >
                            <>
                              <div>
                                <form>
                                  <p className="text-center ">
                                    Select Custom Date{" "}
                                  </p>
                                  <div className="mt-2">
                                    <label htmlFor="start">From</label>
                                    <input
                                      className={`form-control ${
                                        validationErrors.start
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      style={{ width: "100%" }}
                                      type="date"
                                      id="start"
                                      onChange={(value) =>
                                        handleCustomDate(value, "startDate")
                                      }
                                      value={dateRange.start}
                                      name="trip-start"
                                    />
                                    {validationErrors.start && (
                                      <div className="invalid-feedback">
                                        Start date is required.
                                      </div>
                                    )}
                                  </div>
                                  <div className="mt-2">
                                    <label htmlFor="end">To</label>
                                    <input
                                      className={`form-control ${
                                        validationErrors.end ? "is-invalid" : ""
                                      }`}
                                      style={{ width: "100%" }}
                                      type="date"
                                      id="end"
                                      onChange={(value) =>
                                        handleCustomDate(value, "endDate")
                                      }
                                      value={dateRange.end}
                                      name="trip-end"
                                    />
                                    {validationErrors.end && (
                                      <div className="invalid-feedback">
                                        End date is required.
                                      </div>
                                    )}
                                  </div>
                                  <div className="d-flex justify-content-end mt-3 ">
                                    <button
                                      onClick={() => {
                                        setValidationErrors({
                                          start: false,
                                          end: false,
                                        });
                                        setshowCustom(false);
                                      }}
                                      style={{
                                        backgroundColor: "#b2261c",
                                      }}
                                      className="btn rounded-pill text-white px-4  me-2"
                                    >
                                      Close
                                    </button>
                                    <button
                                      onClick={handleApplyDate}
                                      // color="primary"
                                      className="btn rounded-pill text-white px-4"
                                      style={{
                                        backgroundColor: "#169C50",
                                      }}
                                    >
                                      Apply
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </>
                          </div>
                        }
                      />
                    </MyModal>
                  )}
                  <Autocomplete
                    options={sources}
                    value={filters.fromSource || ""}
                    onChange={(event, newValue) => {
                      handleFieldChange("fromSource", newValue || "");
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Source" />
                    )}
                    fullWidth
                    clearOnEscape
                  />
                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <button
                      className="btn btn-danger"
                      onClick={handleClearFilter}
                    >
                      Clear
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={handleApplyFilter}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
    </div>
  );
};

export default TentativeAnalytics;
